import { configureStore, Action, getDefaultMiddleware } from '@reduxjs/toolkit';
import { ThunkAction } from 'redux-thunk';
import { persistStore } from 'redux-persist';
import graphSub from 'api/graph-ws';
import rootReducer, { RootState } from './root';

// import monitorReducerEnhancer from '../enhancers/monitorReducer';

export const store = configureStore({
  reducer: rootReducer,
  middleware: [
    ...getDefaultMiddleware({
      serializableCheck: false,
    }),
    // loggerMiddleware
  ],
});

export type AppDispatch = typeof store.dispatch;

export type AppThunk = ThunkAction<void, RootState, null, Action<string>>;

export const persistor = persistStore(store, {}, () => {
  const { accessToken } = store.getState().auth;
  graphSub.setupConnection({ accessToken });
});
